<template>
  <div>
      <main class="grid">
    <article
        v-for="(dataValue, index) in list" 
        :key="index">
        
      <div class="text" style="text-align: center;">
        
        <p style="font-size: 25px; font-weight: bold;">{{changeDate(dataValue.start_date)}}</p>

        <p>Salon {{dataValue.salon_name}} + Menu <a :href="dataValue.menu_pdf" download class="tag is-danger">{{dataValue.menu_name}}</a></p>
        <p>{{dataValue.guest_count}} invitados</p>
        <p style="font-size: 12px;">{{ dataValue.offer_text }}</p>
        <p>&nbsp;</p>
        <p style="font-size: 22px; font-weight: bold;">Costo Final: <span class="tag" style="background-color: #dfabc6; color: white; font-size: 25px; font-weight: bold;">{{formatCurrency(dataValue.offer_price)}}</span></p>
        <p>&nbsp;</p>
        <p style="font-size: 15px; font-weight: bold;">ESTA OFERTA FINALIZA EN:</p>
        <p>
            <FlipCountdown :deadline="dataValue.discount_end_date+' 00:00:00'"></FlipCountdown>                        
        </p>
        
      </div>
      <div 
        v-if="dataValue.reserved" 
        style="position: relative; top: -40%; left: 0; font-size: 3.5em; font-weight: bold; color: red; rotate: -30deg;">RESERVADO</div>
      <div v-if="!dataValue.reserved" style="margin-bottom: 20px; display: flex; flex-direction: row; width: 100%; justify-content: center; align-items: center;">
          <div 
            class="buttonClass"
            @click="goToAppointment"
            :style="{backgroundColor: 'rgb(255, 95, 223)'}">¡Agenda una visita! 
            <img 
              src="https://www.svgrepo.com/show/444885/calendar.svg" 
              style="width: 20px; margin-left: 10px;" alt=""></div>
          <div 
            class="buttonClass"
            @click="sendWhatsApp(dataValue)"
            :style="{backgroundColor: 'rgb(0, 211, 110)', marginLeft: '10px'}">
            <img 
              src="https://donquijote.b-cdn.net/whatsapp-svgrepo-com.svg" 
              style="width: 20px;" alt=""><span style="margin-left: 10px;">QUIERO + INFO</span></div>
      </div>
    </article>
    
  </main>
  
  </div>
</template>

<script>
export default {
    props: ['list'],
    mounted() {
        window.setInterval(() => {
            this.$store.dispatch('fetchFinancialConfiguration')
        }, 30000)
    },
    methods: {
      goToAppointment() {
        window.location.href='https://app.squarespacescheduling.com/schedule.php?owner=22482463'
      },
      sendWhatsApp(dataValue) {        
        window.location.href='https://wa.me/541152630497?text=Hola%20quisiera%20informacion%20acerca%20de%20la%20promocion%20en%20el%20salon%20'+dataValue.salon_name+',%20para%20la%20fecha%20'+this.changeDate(dataValue.start_date)
      }
    }

}
</script>

<style scoped>

.buttonClass {
  display: flex; 
  flex-direction: row; 
  color: white;
  padding: 5px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
}
   
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-gap: 20px;
  align-items: stretch;
}

.grid > article {
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.3);
}

.grid > article img {
  max-width: 100%;
}

.grid .text {
  padding: 20px;
}


</style>



// WEBPACK FOOTER //
// src/views/Offers/OfferGrid.vue